import FloatRank from "../../../packs_helper/scripts/FloatRank.js";

import InputNumberFixer from "../../../packs_helper/scripts/InputNumberFixer";
import PostData from "../../../packs_helper/scripts/PostData";
import RelativeDate from "../../../packs_helper/scripts/RelativeDate";

FloatRank();
InputNumberFixer();

const otherSkinsMoreButton = document.getElementById('other-skins-more-button');
if(otherSkinsMoreButton){
	const otherSkinsGrid = document.getElementById('other-skins-grid');
	otherSkinsMoreButton.addEventListener('click', function(){
		this.disabled = true;
		const offset = otherSkinsGrid.childElementCount;
		const product_id = otherSkinsGrid.dataset.productId;
		PostData('/same_other_skins', {product_id, offset}).then(response => {
			this.disabled = false;

			if(response){
				otherSkinsGrid.innerHTML = otherSkinsGrid.innerHTML + response;

				setTimeout(() => {
					FloatRank();
					const ranks = otherSkinsGrid.querySelectorAll(".rank-bar-container-fill:not([style])");
					ranks.forEach(function (div) {
						div.style.width = 100 - div.dataset.rank + "%";
					});
        			ReactRailsUJS.mountComponents('[data-react-class="Global/HQuantityField"]');
				}, 100);
			}
			else{
				otherSkinsMoreButton.remove();
			}
		}).catch(err => {
			this.disabled = false;
		})
	})
}

window.ToggleFavorite = (product_id) => {
	let favorite_count = document.getElementById("favorite_count");
	let result_count = 0;
	PostData('/favorilere-ekle', {product_id}).then(response => {
		let favorite_icon, favorite_title, favorite_class;
		if(response.status === 1){
			favorite_icon = "#gs-icon-product-detail-heart-full";
			favorite_title = "Favoriden Kaldır";
			favorite_class = "icon favorite-icon-selected";
			if(parseInt(favorite_count.getAttribute("count")) !== ""){
				result_count = parseInt(favorite_count.getAttribute("count")) + 1;
				favorite_count.innerHTML = result_count;
				favorite_count.setAttribute("count", result_count)
			}else{
				favorite_count.innerHTML = 1;
				favorite_count.setAttribute("count", 1);
			}
			document.getElementById("favorite_"+product_id).setAttribute("title", favorite_title);
			document.getElementById("favorite_icon_"+product_id).setAttribute("class", favorite_class);
			document.getElementById("favorite_icon_result_"+product_id).setAttribute("xlink:href", favorite_icon);
		}else if(response.status === 0){
			favorite_icon = "#gs-icon-product-detail-heart";
			favorite_title = "Favorilere Ekle";
			favorite_class= "icon favorite-icon";
			document.getElementById("favorite_"+product_id).setAttribute("title", favorite_title);
			document.getElementById("favorite_icon_"+product_id).setAttribute("class", favorite_class);
			document.getElementById("favorite_icon_result_"+product_id).setAttribute("xlink:href", favorite_icon);
			if((favorite_count.getAttribute("count") - 1) !== 0){
				result_count = parseInt(favorite_count.getAttribute("count")) - 1
				favorite_count.innerHTML = result_count;
				favorite_count.setAttribute("count", result_count);
			}else{
				favorite_count.innerHTML = "";
				favorite_count.setAttribute("count", 0);
			}
		}

	}).catch(err => {
		this.disabled = false;
	})
}

const lastSeenEl = document.getElementById('last-seen');
let lastSeenResult = RelativeDate(String(lastSeenEl.dataset.seen));
if(
	lastSeenResult == "Şimdi" 
	|| lastSeenResult.includes("sn önce") 
	|| (lastSeenResult.includes("dk önce") && parseInt(lastSeenResult.substr(0,2)) < 6)
  ){ 
	lastSeenResult = '<i class="online" title="Online"></i> Çevrimiçi';
	document.getElementById('last-seen-text').innerHTML = ""
}
lastSeenEl.innerHTML = lastSeenResult;